import React from "react";
import { CourseEnrollmentStats as Stats } from "@/modules/learningCenter/features/CourseManagement/types/course";

interface CourseEnrollmentStatsProps {
  stats: Stats;
}

/**
 * Read-only enrollment summary shown in edit mode: total enrolled and
 * completion rate, sourced directly from the course payload.
 */
export function CourseEnrollmentStats({ stats }: CourseEnrollmentStatsProps) {
  const completionPercent = Math.round((stats.completionRate ?? 0) * 100);

  return (
    <div className="rounded-lg border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-4">
      <h3 className="mb-3 text-base font-normal text-gray-900 dark:text-white">
        Enrollment
      </h3>
      <dl className="grid grid-cols-2 gap-4">
        <div>
          <dt className="text-sm text-gray-500 dark:text-gray-400">
            Total enrolled
          </dt>
          <dd className="text-lg text-gray-900 dark:text-white">
            {stats.totalEnrolled}
          </dd>
        </div>
        <div>
          <dt className="text-sm text-gray-500 dark:text-gray-400">
            Completion rate
          </dt>
          <dd className="text-lg text-gray-900 dark:text-white">
            {completionPercent}%
          </dd>
        </div>
      </dl>
    </div>
  );
}
